import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import styled from 'styled-components';
import { connect } from '../../Store';
import { __ } from '../../Utils';

const MainWrapper = styled.div`
  width: auto;
  height: auto;
  justify-content: center;
  align-items: ${props => (props.alignUnderHeader ? 'flex-start' : 'center')};
  display: flex;
  position: fixed;
  bottom: 0;
  right: 0;
  top: 0;
  left: 0;
  z-index: 8009;
  background: rgba(35, 33, 33, 0.75);
  padding: ${rem(135)} ${rem(30)} ${rem(30)} ${rem(30)};
`;

const PopupWrapper = styled.div`
  position: fixed;
  top: 7%;
  padding-bottom: 15px;
  overflow-y: auto;
  background: white;
  width: 100%;
  z-index: 8011;
  /* ${({ theme }) => theme.media.s`
  width: ${props => (props.fullwidth ? '90%' : rem(500))};
`}; */
  max-width: ${props => (props.fullWidth ? '90%' : rem(500))};
`;

const CloseButton = styled.div`
  width: ${rem(30)};
  height: ${rem(30)};
  background: black;
  float: right;
  margin: ${rem(5)};
  cursor: pointer;
  display: flex;
  justify-content: center;
`;

const MainIconWrapper = styled.div`
  display: flex;
  margin-top: ${rem(30)};
  margin-left: ${rem(30)};
  align-items: center;
  justify-content: center;
`;

const MainText = styled.div`
  display: flex;
  justify-content: center;
  font-size: ${rem(24)};
  font-family: 'Open sans';
  font-weight: 400;
  padding: ${rem(5)};
  text-align: center;
`;

const SubText = styled(MainText)`
  font-weight: 200;
  font-size: ${rem(14)};
`;

const ButtonWrappers = styled.div`
  margin-top: ${rem(10)};
  justify-content: center;
  display: flex;
`;

const ComponentWrapper = styled.div`
  padding: ${rem(10)};
  padding-bottom: ${rem(20)};
  max-height: ${rem(500)};
  overflow: ${props => (props.scroll ? 'scroll' : 'unset')};
  ${({ theme }) => theme.media.s`
  max-height: unset;
  overflow: unset;
  background: white;
`};
`;

class AlertPopup extends React.Component {
  render() {
    const {
      alert,
      success,
      question,
      onClose,
      display,
      text,
      subText,
      onSubmit,
      onDismiss,
      component,
      alignUnderHeader,
      scrollContent,
      styles,
      fullWidth,
    } = this.props;
    const custom = !alert && !success && !question;
    let iconName = '';
    let color = '';

    if (alert) {
      iconName = 'exclamation';
      color = 'red';
    } else if (success) {
      iconName = 'info';
      color = 'green';
    } else if (question) {
      iconName = 'question';
      color = 'orange';
    }

    return display ? (
      <MainWrapper alignUnderHeader={alignUnderHeader}>
        <PopupWrapper custom={custom} style={styles} fullWidth={fullWidth}>
          <CloseButton onClick={() => onClose()}>
            <Icon name="forbidden" size="m" color="white" />
          </CloseButton>
          {!custom ? (
            <div>
              <MainIconWrapper>
                <Icon name={iconName} size="xxl" color={color} />
              </MainIconWrapper>
              {text.length > 0 && <MainText>{text}</MainText>}
              {subText.length > 0 && <SubText>{subText}</SubText>}
              <ButtonWrappers>
                {success && (
                  <Button primary onClick={() => onSubmit()}>
                    {__('Ok')}
                  </Button>
                )}
                {alert && (
                  <React.Fragment>
                    <Button danger onClick={() => onSubmit()}>
                      {__('Áno')}
                    </Button>
                    <Button onClick={() => onDismiss()}>{__('Zrušiť')}</Button>
                  </React.Fragment>
                )}
                {question && (
                  <React.Fragment>
                    <Button primary onClick={() => onSubmit()}>
                      {__('Áno')}
                    </Button>
                    <Button onClick={() => onDismiss()}>{__('Zrušiť')}</Button>
                  </React.Fragment>
                )}
              </ButtonWrappers>
            </div>
          ) : (
            <ComponentWrapper scroll={scrollContent}>
              {component}
            </ComponentWrapper>
          )}
        </PopupWrapper>
      </MainWrapper>
    ) : (
      <React.Fragment />
    );
  }
}

AlertPopup.propTypes = {
  styles: PropTypes.object, //eslint-disable-line
  alert: PropTypes.bool,
  success: PropTypes.bool,
  question: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onDismiss: PropTypes.func,
  text: PropTypes.string,
  subText: PropTypes.string,
  display: PropTypes.bool,
  alignUnderHeader: PropTypes.bool,
  component: PropTypes.node,
  scrollContent: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

AlertPopup.defaultProps = {
  styles: {},
  alert: false,
  success: false,
  question: false,
  onSubmit: () => {},
  onDismiss: () => {},
  text: '',
  subText: '',
  display: false,
  alignUnderHeader: false,
  scrollContent: false,
  component: <div />,
  fullWidth: false,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(AlertPopup);



// WEBPACK FOOTER //
// ./src/Components/AlertPopup/index.jsx